// Internal modules
import { $logger } from '@/lib/logger';

// All countries support en so we use that as a fallback
const FALLBACK_LANGUAGE = 'en';

export const getSuggestedDefaultLanguageForCountry = ({
  countryCode,
  territories,
}) => {
  const data = territories.find(({ code }) => code === countryCode);

  if (!data) {
    $logger.info('suggested_default_langauge_not_found', {
      countryCode,
    });
    return FALLBACK_LANGUAGE;
  }

  return data.suggestedDefaultLanguage;
};
